import React from 'react';
import { useTranslation } from 'react-i18next';

const ButtonCategory = ({ category, name, activePage, handleNavigationChange }) => {
  const { t } = useTranslation();

  return (
    <a
      href="#"
      className={`menu-bar-item ${activePage === category ? 'router-link-active router-link-exact-active menu-bar-item' : ''}`}
      onClick={() => handleNavigationChange(category)}
    >
      {/* <div className="navigation-item-badge">{t('NEW')}</div> */}<img  src={`/assets/img/icon-btn/${category}-icon.png`} className="HomeSection_icon" />
      {t(name)}
    </a>
  );
};

export default ButtonCategory;
